<mat-progress-spinner mode="indeterminate" [diameter]="50"></mat-progress-spinner>